import { confirmAlert } from 'react-confirm-alert';
import styles from './index.module.scss';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import classNames from 'classnames';
import { Button } from '@mui/material';

export default function clinicalEventConfirmAlert({
  title,
  body,
  label,
  onClick,
  primaryBtnText,
  classes,
  cancelText,
  onCancelClick,
}: {
  title: string;
  body: string;
  label?: string;
  onClick: () => void;
  classes?: {
    btn?: string;
    body?: string;
    sureText?: string;
  };
  primaryBtnText?: string;
  cancelText?: string;
  onCancelClick?: () => void;
}) {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className={classNames('flex flex-col', styles.contentWrapper)}>
          <h1>{title}</h1>
          <div className={classNames(styles.attention, classes?.body)}>
            <ErrorOutlineOutlinedIcon />
            <div>
              <div className={'font-semibold'}>{label ?? 'Attention!'}</div>
              {body}
            </div>
          </div>
          <div
            className={classNames(
              'flex flex-wrap items-center justify-between mt-5 gap-2',
              styles.actionWrapper,
            )}
          >
            <div
              className={classNames(
                'text-neutrals-n-400 text-sm font-semibold ',
                classes?.sureText,
              )}
            >
              Are you sure?
            </div>
            <div
              className={classNames('flex items-center gap-2', styles.btnsContainer)}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  onCancelClick?.();
                  onClose();
                }}
                className={styles.confirmbutton}
              >
                {cancelText ?? 'Cancel'}
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  onClick();
                  onClose();
                }}
                className={classNames(styles.confirmbutton, styles.primary, classes?.btn)}
              >
                {primaryBtnText}
              </Button>
            </div>
          </div>
        </div>
      );
    },
    overlayClassName: styles.confirmPopup,
  });
}
